import React from "react";
import ReactGa from "react-ga";

function Analytics() {
  const GA_id = "UA-272790041-2";
  ReactGa.initialize(GA_id);
  ReactGa.pageview(window.location.pathname + window.location.search);
}

export default Analytics;
